import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { VotingDetailsComponent } from "./voting-details.component";
import { TranslateModule } from "@ngx-translate/core";
import { ResultSummaryModule } from '../result-summary/result-summary.module';
import { SimpleResultSummaryModule } from '../simple-result-summary/simple-result-summary.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ResultSummaryModule,
        SimpleResultSummaryModule
    ],
  declarations: [
    VotingDetailsComponent
  ],
  exports: [
    VotingDetailsComponent
  ]
})
export class VotingDetailsModule {}
